import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListeCarteImageNom } from '@components/liste-carte-image-nom/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { Finition } from '@shared/services/elastic-search/models';
import { LogsService } from '@shared/services/logs';
import { take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-liste-carte-image-nom',
  templateUrl: './liste-carte-image-nom.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OptionCardComponent, RouterLink, SvgComponent],
})
export class ListeCarteImageNomComponent extends AbstractDynamicComponent<ListeCarteImageNom> implements OnInit {
  protected readonly finitions = signal<Finition[]>([]);
  private readonly elasticSearchService = inject(ElasticSearchService);
  private readonly logs = inject(LogsService);

  ngOnInit() {
    const context = this.data.context;

    const finitions$ =
      context === 'cuisine-sur-mesure'
        ? this.elasticSearchService.getCustomKitchens()
        : this.elasticSearchService.getFinitions(context);

    finitions$
      .pipe(
        take(1),
        tap((finitions) => {
          this.finitions.set(finitions);
        })
      )
      .subscribe({ error: (err) => this.logs.error('ListeCarteImageNomComponent', 'Loading finitions failed', err) });
  }
}
